import { Alert } from '@mui/material';
import { useRecordContext } from 'react-admin';

// Campos que vivem no Remote Config do Firebase. Redes sem service account
// cadastrada não têm Remote Config — nesses casos os campos são ocultados.
export const FirebaseOnly = ({ children }) => {
  const record = useRecordContext();
  if (record && record.hasFirebaseConfig === false) { return null; }
  return children;
};

export const FirebaseMissingAlert = () => {
  const record = useRecordContext();
  if (!record || record.hasFirebaseConfig !== false) { return null; }
  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      Esta rede não possui integração com o Firebase configurada. As opções que dependem do
      Remote Config (cards da home, textos e ajustes do app) ficam indisponíveis até que o
      arquivo de service account seja cadastrado no cadastro da rede.
    </Alert>
  );
};

export const orderCards = (settings) => {
  if (!settings.firebaseConfig?.home_cards) { return settings; }
  const cardsArr = settings.firebaseConfig.home_cards;

  if (cardsArr && cardsArr.length) {
    cardsArr.forEach((card, index) => {
      card.index = index;
      if (card.imagefile) {
        card.updateImage = true;
      }
    });
  }

  return settings;
};
